import { useEffect, useState } from "react";
import { fetchWithAuth } from "../../api/fetchWithAuth";

export default function OperatingAoiCoveragePanel({ aoiId }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!aoiId) return;

    async function load() {
      setLoading(true);
      const res = await fetchWithAuth(
        `/api/v1/platform/operating-aois/${aoiId}/imagery-coverage`
      );
      const data = await res.json();
      setRows(data.coverage || []);
      setLoading(false);
    }

    load();
  }, [aoiId]);

  if (!aoiId) return null;

  return (
    <div className="border-t border-bg-border bg-bg-soft p-3 text-xs">
      <div className="font-semibold mb-2">Imagery Coverage</div>

      {loading && <div className="text-gray-400">Loading…</div>}

      {!loading && rows.length === 0 && (
        <div className="text-fg-secondary">No imagery covers this AOI</div>
      )}

      {!loading && rows.map(r => (
        <div key={r.id} className="mb-2">
          <div className="flex justify-between">
            <span>{r.name}</span>
            <span>{Math.round(r.coverage_pct * 100)}%</span>
          </div>
          <div className="h-1 bg-bg rounded">
            <div
              className="h-1 bg-accent-info rounded"
              style={{ width: `${Math.min(100, r.coverage_pct * 100)}%` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}